var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdsButton',_vm._g(_vm._b({staticClass:"mr-3",attrs:{"loading":_vm.$store.state.isLoading,"secondary":"","outlined":"","icon":"mdi-content-save-outline","button-text":"Save as draft"}},'AdsButton',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }